/**
 * ProtectedRoute — guard de rutas que requieren sesión activa.
 *
 * Si no hay usuario logueado, redirige a `/login` y guarda la URL pretendida
 * en `location.state` para volver después del login (deeplinking básico).
 */

import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSessionStore } from '@/stores/session';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const usuario = useSessionStore((s) => s.usuario);
  const location = useLocation();

  if (!usuario) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
